import { memo } from "react";
import Head from "../components/Head/Head";
import Sections from "../components/Sections/Sections";
import ArtPage from "../components/Art/ArtPage";
import Navigation from "../components/Head/subComponents/Navigation";
import MadeByOlaBanner from "../components/BottomBanner/MadeByOlaBanner";

function Home() {
  return (
    <div className="w-full min-h-screen h-full flex flex-col justify-start items-start">
      <Head />

      <div className="sticky top-0 w-full bg-white/60 backdrop-blur-sm">
        <Navigation />
      </div>

      <div className="px-3 md:px-10 w-full py-10 md:py-16">
        <ArtPage />
      </div>

      <div className="w-full pb-2 px-3 md:px-10">
        
        <Sections />
        <MadeByOlaBanner />
      </div>
    </div>
  );
}

export default memo(Home);
